import addSurplusTemp from './src/addSurplusTemp.vue'

export default addSurplusTemp
